import { h, Component } from 'preact';
import {Container, CreditCardIcon, CreditCardNumber} from 'components/elements'
import style from './style'

export default (props)=>(
    <Container class={style.card} onClick={props.onClick}>
        <CreditCardIcon type={props.card.cardType} class={style.icon} />
        <div class={style.cardNumber}>
            <div>{props.card.name}</div>
            <CreditCardNumber cardNumber={props.card.cardNumber} />
        </div>
        <div class={style.expires}>
            Expires {props.card.expMonth}/{props.card.expYear}
        </div>
    </Container>
)


// WEBPACK FOOTER //
// ./components/groups/CreditCard/index.js